import { handleResponse, handleError, authHeader } from "./apiUtils";
import axios from "axios";
import { API_ROOT } from "./api-config";

const base = API_ROOT + "dept/";

export function getDepartment() {
  return axios({
    method: "GET",
    url: base + "GetDepartment",
    headers: authHeader()
  })
    .then(handleResponse)
    .catch(handleError);
}
